<template>
    <div class="base-card__content">
        {{ title }}
    </div>
</template>

<script setup lang="ts">
    import { type PropType, computed } from "vue";
    import { type SeasonsCardData } from "../../models";
    import { Strings } from "@/locales/types/enums/strings";
    import { useI18n } from "vue-i18n";

    const props = defineProps({
        cardData: {
            type: Object as PropType<SeasonsCardData>,
            required: true
        },
    });

    const { t } = useI18n();

    const title = computed((): string => `${t(Strings.DETAILS_SEASON).toString()} ${props.cardData.getSeasonNumber()}`);
</script>

<style lang="scss">
    @import url("styles.scss");
</style>